/**
 * @generated SignedSource<<ec55314dc46e776a17b26a38014a1afb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpvoteAction = "Downvote" | "Upvote" | "%future added value";
export type UpvoteType = "Article" | "Author" | "Podcast" | "Section" | "Topic" | "Video" | "%future added value";
export type hooksReactionMutation$variables = {
  action: UpvoteAction;
  targetEntityId: string;
  type: UpvoteType;
};
export type hooksReactionMutation$data = {
  readonly upvote: {
    readonly id: string;
    readonly upvoted: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"contentReactionDisplayUpvote">;
  };
};
export type hooksReactionMutation = {
  response: hooksReactionMutation$data;
  variables: hooksReactionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "action"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetEntityId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v3 = [
  {
    "kind": "Variable",
    "name": "action",
    "variableName": "action"
  },
  {
    "kind": "Variable",
    "name": "targetEntityId",
    "variableName": "targetEntityId"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "upvoted",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksReactionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Upvote",
        "kind": "LinkedField",
        "name": "upvote",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "contentReactionDisplayUpvote"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "hooksReactionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Upvote",
        "kind": "LinkedField",
        "name": "upvote",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5f5ec3b37a31333912998adbdb5ef051",
    "id": null,
    "metadata": {},
    "name": "hooksReactionMutation",
    "operationKind": "mutation",
    "text": "mutation hooksReactionMutation(\n  $targetEntityId: String!\n  $action: UpvoteAction!\n  $type: UpvoteType!\n) {\n  upvote(targetEntityId: $targetEntityId, action: $action, type: $type) {\n    id\n    upvoted\n    ...contentReactionDisplayUpvote\n  }\n}\n\nfragment contentReactionDisplayUpvote on Upvote {\n  upvoted\n  updatedAt\n}\n"
  }
};
})();

(node as any).hash = "186c06c9fa1e7dbcf805c757c14b0620";

export default node;
